import React, { useEffect, useContext } from 'react';
import { useFlags } from 'launchdarkly-react-client-sdk';
import {
  AppContext,
  useActivityTracker,
  useIsAuthorisedHook
} from '@nile/components';
import envConfig from '@nile/home/src/Config/env';
import TabContext from '@nile/mangifera/src/Contexts/TicketContext';

function AppInfoNavigation() {
  const flags = useFlags();
  const appContext = useContext(AppContext);
  const tabContext = useContext(TabContext);
  const timeSheerViewPermission = useIsAuthorisedHook('allTimesheet.allow');

  const messageUsCallback = () => {
    window.Intercom('showNewMessage');
  };
  const toggleAgentModal = () => {
    tabContext.openTab({
      module: 'RMM_HOME',
      url: '/rmm/asset-view/4001',
      state: {
        downloadAgentModal: true
      }
    });
  };

  const toggleDataReportModal = () => {
    tabContext.openTab({
      module: 'REPORTS_CHARTS_HOME',
      url: '/datareport/1/view',
      state: {
        openDataReportModal: true
      }
    });
  };

  const myHandler = (eventName, eventData) => {
    if (eventName === 'abandoned_search') {
      useActivityTracker({
        event: 'Command bar search text',
        data: { searchText: eventData?.inputText, source: 'command bar' }
      });
    }
  };
  const init = () => {
    const loggedInUserId = appContext?.user?.customerId;
    const loggedInUserEmail = appContext?.user?.email;
    const currentProduct = appContext?.currentProduct;

    window?.CommandBar?.boot(`${loggedInUserEmail} - ${loggedInUserId}`);
    window?.CommandBar?.addMetadataBatch({
      name: `${appContext?.user.firstName} ${appContext?.user.lastName}`,
      email: appContext?.user.email,
      accountId: appContext?.user.userId,
      Subdomain:
        envConfig.mode !== 'development'
          ? window.location.hostname.split('.')[0]
          : 'dev',
      Plan: appContext?.user.chargeBeePlanId,
      accountType: appContext?.user?.accountType,
      timeSheetManagerView: timeSheerViewPermission,
      subscriptionStatus: appContext?.user.subscriptionStatus,
      productType: currentProduct
    });
    window.CommandBar.addEventSubscriber(myHandler);
    window.CommandBar.addCallback('openNewIntercomMessage', messageUsCallback);
    window.CommandBar.addCallback('openDownloadAgent', toggleAgentModal);
    window.CommandBar.addCallback('openDataReportModal', toggleDataReportModal);
  };
  useEffect(() => {
    const isMSP = appContext?.user?.accountType === 'MSP';
    if (flags?.commandbar && isMSP && window?.CommandBar) {
      init();
    }
  }, [flags]);
  return <></>;
}
export default AppInfoNavigation;
